var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { withRouter } from "../componentWrappers";
import { requestState } from "./helpers/requestState";
import { MapView } from "./components/MapView";
import LibraryLayout from "./LibraryLayout";
import Library from "./Library";
import LibraryModeToggleButtons from "./components/LibraryModeToggleButtons";
import { trackPage } from "../App/GoogleAnalytics";

class LibraryMapComponent extends Library {
  static async requestState(requestParams, globalResources) {
    return requestState(requestParams, globalResources, { geolocation: true });
  }

  render() {
    trackPage();
    return /*#__PURE__*/(
      _jsx(LibraryLayout, { className: "library-map-layout" }, void 0, /*#__PURE__*/
      _jsx(LibraryModeToggleButtons, { mapViewMode: true }), /*#__PURE__*/
      React.createElement(MapView, {
        storeKey: "library",
        ref: (ref) => {
          this.mapView = ref;
        } }
      )
      ));

  }
}
const SSRLibraryComponent = withRouter(LibraryMapComponent);

const LibraryMap = Object.assign(SSRLibraryComponent, {
  requestState: LibraryMapComponent.requestState
});

export { LibraryMapComponent };
export { LibraryMap };